export const greet = (): string => {
  const now = new Date()
  const hour = now.getHours()

  if (hour < 4 || hour >= 18) return 'Boa noite'
  if (hour < 12) return 'Bom dia'
  return 'Boa tarde'
}
